// Auto-categorization API (/api/autocat). Every call names the business.
import apiClient from '../../shared/services/apiClient';

const p = (businessId, extra = {}) => ({ params: { business_id: businessId, ...extra } });

export const autocatAPI = {
  settings: (b) => apiClient.get('/autocat/settings', p(b)),
  saveSettings: (b, data) => apiClient.put('/autocat/settings', data, p(b)),
  run: (b) => apiClient.post('/autocat/run', {}, p(b)),
  queue: (b, offset = 0) => apiClient.get('/autocat/queue', p(b, { offset, limit: 50 })),
  accept: (b, id, always) => apiClient.post(`/autocat/queue/${id}/accept`, { always }, p(b)),
  change: (b, id, categoryId, always) => apiClient.post(`/autocat/queue/${id}/change`, { category_id: categoryId, always }, p(b)),
  undo: (b, id) => apiClient.post(`/autocat/transactions/${id}/undo`, {}, p(b)),
  history: (b, id) => apiClient.get(`/autocat/transactions/${id}/history`, p(b)),
  rules: (b) => apiClient.get('/autocat/rules', p(b)),
  createRule: (b, data) => apiClient.post('/autocat/rules', data, p(b)),
  updateRule: (b, id, data) => apiClient.put(`/autocat/rules/${id}`, data, p(b)),
  disableRule: (b, id) => apiClient.delete(`/autocat/rules/${id}`, p(b)),
  previewRule: (b, id) => apiClient.get(`/autocat/rules/${id}/preview`, p(b)),
  applyRule: (b, id, expectedCount) => apiClient.post(`/autocat/rules/${id}/apply-existing`, { confirm: true, expected_count: expectedCount }, p(b)),
  transfers: (b, kind = 'transfer') => apiClient.get('/autocat/transfers', p(b, { kind })),
  decideTransfer: (b, id, accept) => apiClient.post(`/autocat/transfers/${id}/${accept ? 'accept' : 'reject'}`, {}, p(b)),
};

export const SOURCE_LABEL = {
  rule: 'Your rule',
  history: 'Past choices',
  plaid_default: 'Bank category',
  transfer_match: 'Transfer match',
};

// Plain-language confirm text for "apply to existing rows".
export function applyConfirmText(preview) {
  const lines = preview.preview.slice(0, 5).map((r) => `• ${r.transaction_date}  ${r.description}  $${Number(r.amount).toFixed(2)}`);
  const more = preview.count > 5 ? `\n…and ${preview.count - 5} more` : '';
  return `Apply this rule to ${preview.count} uncategorized row(s) in open periods? Rows you categorized yourself are never changed.\n\n${lines.join('\n')}${more}`;
}
